import { MarkRequired } from 'ts-essentials';
import { TcFileFolderItem } from '@data-access/connect/tc-tcps';
import { LoadableItem, LoadableItems, LoadState } from '@trimble/data-loading';
import { RunStatus } from '@data-access/geospatial/mobile-mapping';
import {
  PointcloudStatus,
  StationTransform,
} from '@data-access/geospatial/scan-data';
import { ClassStatistics } from '@trimble/types';

export type RunItem = {
  id: string; // pointCloudTrn
  runId: string;
  name: string;
  beginStation: number;
  endStation: number;
  /** Populated after image-based station grouping completes for this run in the viewer. */
  numberOfStations?: number;
  color?: { r: number; g: number; b: number };
  status: RunStatus | undefined;
};

export type MissionItem = LoadableItem & {
  name: string;
  missionTrn: string;
  runs: RunItem[];
  pathId: string | null | undefined;
};

export type PointCloudItem = LoadableItem & {
  name: string;
  status: PointcloudStatus;
  pointCount: number;
  mission?: MissionItem;
  classStatistics?: ClassStatistics;
  stationTransform?: StationTransform;
};

export type TrajectoryItem = LoadableItem & {
  name: string;
  beginStation: number;
  endStation: number;
  sourceFileId: string;
  mission?: MissionItem;
  isSplittable: boolean | undefined;
};

export type MissionPathItem = MarkRequired<TrajectoryItem, 'mission'>;

export type FileFolderItem = LoadableItem & TcFileFolderItem;

export type RunDetailsSelection = Pick<RunItem, 'id' | 'runId' | 'name'> & {
  readonly missionTrn: string;
};

export type MissionDetailsSelection = Pick<MissionItem, 'missionTrn' | 'name'>;

export type ClassificationSchemeItem = {
  id: number;
  name: string;
  rgba: string;
  visible: boolean;
};

export type ProjectDataState = {
  mission: LoadableItems<MissionItem>;
  pointCloud: LoadableItems<PointCloudItem>;
  trajectory: LoadableItems<TrajectoryItem>;
  tcFileFolder: LoadableItems<FileFolderItem>;
};

/** Active path navigation alignment and station run, synced from PathNavigationCoordinator and StationsCapabilityProvider. */
export type ActiveItems = {
  alignmentId: string | null;
  pointCloudTrnId: string | null;
};

export const defaultProjectDataState: ProjectDataState = {
  mission: { state: LoadState.NotLoaded },
  pointCloud: { state: LoadState.NotLoaded },
  trajectory: { state: LoadState.NotLoaded },
  tcFileFolder: { state: LoadState.NotLoaded },
};
